export default class Booking {
  /**
   * @param {object} config Parameters for creating a booking
   * @param {object} config.customer
   * @param {string} config.enterDateTime
   * @param {string} config.exitDateTime
   * @param {string} config.labelAbbreviation
   * @param {string} config.locationAbbreviation
   * @param {string} config.paymentLocation
   * @param {string} config.productAbbreviation
   */
  constructor(config = {}) {
    const params = Object.assign({}, {
      customer: {
        firstName: null,
        lastName: null,
        email: null,
        mobileNumber: null,
        numberOfPersons: 1,
      },
      currencyCode: 'EUR',
      enterDateTime: null,
      exitDateTime: null,
      labelAbbreviation: null,
      locationAbbreviation: null,
      paymentLocation: null,
      productAbbreviation: null,
    }, config);

    return $.ajax({
      url: ajax_object.ajax_url,
      method: 'POST',
      dataType: 'json',
      data: {
        action: 'quick_parking/create_booking',
        parameters: params,
      },
    });
  }
}
